module.exports = __webpack_public_path__ + "static/media/user-hard-hat.bf0bf929.svg";